// src/hooks/results/useRespiratoryResults.js
import { useMeasurementResults } from "./useMeasurementResults";

export function useRespiratoryResults(
  db,
  uid,
  { pageSize = 50, subjectId = null } = {},
) {
  return useMeasurementResults(db, uid, {
    collectionName: "RecordingTidalBreathing",
    context: "respiratory",
    pageSize,
    subjectId,
  });
}
